import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const VendorSignupVerification = () => {
  const [acknowledged, setAcknowledged] = useState(false);
  const navigate = useNavigate();

  const handleAcknowledge = async () => {
    setAcknowledged(true);
    // Get user from localStorage
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    try {
      // Update is_background_checked to 1 in the users table
  await fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/api/user/${user.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ is_background_checked: 1 }),
      });
      // Optionally update localStorage as well
      localStorage.setItem('user', JSON.stringify({ ...user, is_background_checked: 1 }));
    } catch (err) {
      // Optionally handle error
    }
    setTimeout(() => {
      navigate('/vendordashboard');
    }, 1200);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Vendor Signup Verification</h2>
      <div style={styles.text}>
        By clicking on the <strong>Acknowledgement</strong> button, you accept Jaca's terms and conditions.
        All accounts are verified for accuracy. In the event there are malicious intent, those accounts will be removed immediately.
      </div>
      <button
        style={styles.button}
        onClick={handleAcknowledge}
        disabled={acknowledged}
      >
        {acknowledged ? 'Acknowledged' : 'Acknowledgement'}
      </button>
      {acknowledged && (
        <div style={styles.successMsg}>
          Thank you for acknowledging. Redirecting to your dashboard...
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '500px',
    margin: '60px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
    fontFamily: 'Segoe UI, Arial, sans-serif',
    textAlign: 'center',
  },
  title: {
    marginBottom: '24px',
    color: '#4078c0',
    fontSize: '1.6rem',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  text: {
    color: '#444',
    fontSize: '1.08rem',
    marginBottom: '32px',
    lineHeight: 1.6,
  },
  button: {
    background: '#388e3c',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '12px 32px',
    fontSize: '1.08rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #c8e6c9',
    transition: 'background 0.2s',
  },
  successMsg: {
    marginTop: '24px',
    color: '#388e3c',
    fontWeight: 'bold',
    fontSize: '1.08rem',
  },
};

export default VendorSignupVerification;